import { fetchElements } from "@/lib/utils"

import type {
  SidebarMenuDirectus,
  SidebarItemsDirectus,
  PageDirectus,
  SubPageDirectus,
  MenuTenantsDirectus,
  MenuPageRelationDirectus,
} from "@/types/models/menu"
import type { MenuRepository } from "@/lib/repositories/interfaces/menu-repository.interface"

const MENU_FIELDS = ["*"] as const

const SIDEBAR_ITEMS_FIELDS = [
  "*",
  "translations.*",
] as const

const PAGES_FIELDS = [
  "*",
  "translations.*",
] as const

const SUBPAGES_FIELDS = [
  "*",
  "translations.*",
] as const

const MENU_TENANTS_FIELDS = ["*"] as const

const MENU_TENANTS_PAGES_FIELDS = ["*"] as const

export async function fetchSidebarMenuRepository() {
  return await fetchElements<SidebarMenuDirectus>(
    "sidebarMenu",
    [...MENU_FIELDS]
  )
}

export async function fetchSidebarItemsRepository() {
  return await fetchElements<SidebarItemsDirectus>(
    "sidebarItems",
    [...SIDEBAR_ITEMS_FIELDS]
  )
}

export async function fetchPagesRepository() {
  return await fetchElements<PageDirectus>(
    "pages",
    [...PAGES_FIELDS]
  )
}

export async function fetchSubPagesRepository() {
  return await fetchElements<SubPageDirectus>(
    "subpages",
    [...SUBPAGES_FIELDS]
  )
}

export async function fetchMenuTenantsRepository(
  tenantId: number
) {
  return await fetchElements<MenuTenantsDirectus>(
    "menus_tenants",
    [...MENU_TENANTS_FIELDS],
    undefined,
    {
      tenant: {
        _eq: tenantId,
      },
    }
  )
}

export async function fetchMenuTenantsPagesRepository(
  menuTenantId: number
) {
  return await fetchElements<MenuPageRelationDirectus>(
    "menus_tenants_pages",
    [...MENU_TENANTS_PAGES_FIELDS],
    undefined,
    {
      menus_tenants_id: {
        _eq: menuTenantId,
      },
    }
  )
}

export const menuRepository: MenuRepository = {
  fetchSidebarMenu: fetchSidebarMenuRepository,
  fetchSidebarItems: fetchSidebarItemsRepository,
  fetchPages: fetchPagesRepository,
  fetchSubPages: fetchSubPagesRepository,
  fetchMenuTenants: fetchMenuTenantsRepository,
  fetchMenuTenantsPages: fetchMenuTenantsPagesRepository,
}
